"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchBlobWithFileName = exports.useFetchBlob = exports.useFetchFile = exports.saveData = exports.useFetchJson = exports.fetchJson = void 0;
const content_disposition_1 = require("content-disposition");
const error_1 = require("./error");
function isInterlayerExtensionList(message) {
    if (!Array.isArray(message) || message.length === 0)
        return false;
    const first = message[0];
    if (first === null || typeof first !== "object")
        return false;
    const m = first;
    if (typeof m.message !== "string")
        return false;
    if ("property" in m || "constraints" in m)
        return false;
    return true;
}
function isClassValidatorErrorList(message) {
    if (!Array.isArray(message) || message.length === 0)
        return false;
    const first = message[0];
    return first !== null && typeof first === "object" && ("property" in first || "constraints" in first);
}
const getApiError = async (response) => {
    var _a;
    const contentType = ((_a = response.headers.get("content-type")) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || "";
    if (contentType.includes("application/json")) {
        const json = (await response.json());
        if (isInterlayerExtensionList(json.message)) {
            const text = json.message.map(m => m.message).join(" ");
            return new error_1.ApiError(text || response.statusText, response.status, undefined, json.message);
        }
        if (response.status === 400 &&
            Array.isArray(json.message) &&
            json.message.length > 0 &&
            json.message.every((x) => typeof x === "string")) {
            const text = json.message.join(" ");
            return new error_1.ApiError(text || response.statusText, response.status);
        }
        if (response.status === 400 && isClassValidatorErrorList(json.message)) {
            return new error_1.ApiError(response.statusText, response.status, json.message);
        }
        if (typeof json.message === "string") {
            return new error_1.ApiError(json.message, response.status);
        }
        if (json.message !== undefined) {
            return new error_1.ApiError(typeof json.message === "string" ? json.message : JSON.stringify(json.message), response.status);
        }
        return new error_1.ApiError(response.statusText, response.status);
    }
    const text = await response.text();
    const isHtmlResponse = contentType.includes("text/html") || text.trimStart().startsWith("<!DOCTYPE");
    const message = isHtmlResponse ? `Request failed with status ${response.status}` : text || response.statusText;
    return new error_1.ApiError(message, response.status);
};
const fetchJson = async (input, init) => {
    const response = await window.fetch(input, init);
    if (response.status === 204) {
        return null;
    }
    if (response.status === 401) {
        return response;
    }
    if (![200, 201].includes(response.status)) {
        throw await getApiError(response);
    }
    return response.json();
};
exports.fetchJson = fetchJson;
const useFetchJson = () => {
    return {
        fetchJson: async (input, init) => {
            const response = await window.fetch(input, init);
            if (response.status === 204) {
                return null;
            }
            if (response.status === 401) {
                return response;
            }
            if (response.status === 403) {
                throw await getApiError(response);
            }
            if (![200, 201].includes(response.status)) {
                throw await getApiError(response);
            }
            return response.json();
        },
    };
};
exports.useFetchJson = useFetchJson;
const saveData = async (blob, fileName) => {
    const showSaveFilePicker = window.showSaveFilePicker;
    if (typeof showSaveFilePicker === "function" && fileName) {
        try {
            const handle = await showSaveFilePicker({ suggestedName: fileName });
            const writable = await handle.createWritable();
            try {
                await writable.write(blob);
            }
            finally {
                await writable.close();
            }
            return true;
        }
        catch (error) {
            if (error instanceof DOMException && error.name === "AbortError") {
                return false;
            }
        }
    }
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.style.display = "none";
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;
    a.click();
    document.body.removeChild(a);
    setTimeout(() => window.URL.revokeObjectURL(url), 100);
    return true;
};
exports.saveData = saveData;
const useFetchFile = () => {
    return {
        fetchFile: async (input, init) => {
            const response = await window.fetch(input, init);
            if (response.status === 204) {
                return;
            }
            if (response.status === 401) {
                return response;
            }
            if (![200, 201].includes(response.status)) {
                throw await getApiError(response);
            }
            const contentDisposition = response.headers.get("Content-Disposition");
            const parameters = contentDisposition ? (0, content_disposition_1.parse)(contentDisposition).parameters : {};
            // it is fine to keep filename empty, then real name would be something like uuid
            const blob = await response.blob();
            await (0, exports.saveData)(blob, parameters.filename);
        },
    };
};
exports.useFetchFile = useFetchFile;
const useFetchBlob = () => {
    return {
        fetchBlob: async (input, init) => {
            const response = await window.fetch(input, init);
            if (response.status === 204) {
                return new Blob();
            }
            if (response.status === 401) {
                return response;
            }
            if (![200, 201].includes(response.status)) {
                throw await getApiError(response);
            }
            return response.blob();
        },
    };
};
exports.useFetchBlob = useFetchBlob;
const useFetchBlobWithFileName = () => {
    return {
        fetchBlobWithFileName: async (input, init) => {
            var _a;
            const response = await window.fetch(input, init);
            if (response.status === 204) {
                return new Blob();
            }
            if (response.status === 401) {
                return response;
            }
            if (![200, 201].includes(response.status)) {
                throw await getApiError(response);
            }
            return {
                blob: await response.blob(),
                fileName: (0, content_disposition_1.parse)((_a = response.headers.get("Content-Disposition")) !== null && _a !== void 0 ? _a : "").parameters.filename || "file",
            };
        },
    };
};
exports.useFetchBlobWithFileName = useFetchBlobWithFileName;
//# sourceMappingURL=fetch.js.map